module.exports = __webpack_public_path__ + "img/04_03.cf5152ef.png";